import { paymentMethodKey } from '../utils/tableFilters'

/**
 * Renders a backend payment-method string as a human label. Falls back to the
 * raw value so an unexpected method is still visible rather than hidden.
 *
 * Bucketing lives in `paymentMethodKey` so this label and the Method filter
 * always agree on what counts as a card or a manual payment.
 */
export const formatPaymentMethod = (
  t: (key: string) => string,
  method?: string | null,
): string => {
  switch (paymentMethodKey(method)) {
    case 'none':
      return '-'
    case 'card':
      return t('card')
    case 'manual':
      return t('manualPayment')
    default:
      return method as string
  }
}
